
export class EmailReturnOrder {
    orderId: string;
    customerName: string;
    deliveryAddress: any;
    returnOrderDetails: any;
    emailId: string;
}
